import React from 'react'
import { Route } from 'react-router-dom'
import ConsoleFAQ from '../../../views/Dashboard/Configurations/ConsoleFAQ'
import SmartChatView from 'components/SmartChatView'

const ConsoleFAQRoutes = ({ match }) => (
  <>
    <Route exact path={[`${match.path}/console`, `${match.path}/console/:assistantId`]} component={ConsoleFAQ} />
    <Route exact path={`${match.path}/smartchat`} component={SmartChatView} />
  </>
)

export default ConsoleFAQRoutes
